/* eslint-disable consistent-return */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import axios from 'axios';
// import ReactFileReader from 'react-file-reader';
//import { ExportToCsv } from 'export-to-csv';

import { CSVLink, CSVDownload } from 'react-csv';
import { mkConfig, generateCsv, download } from "export-to-csv";
import Papa from 'papaparse';
import { ReactReader } from 'react-reader'
import Loader from '../../Common/Loader';
import constants from '../../../constants';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import { checkRole } from '../../Common/CheckRole';
const { serverUrl, ENCRYPTOR_KEY, REDIRECT_URL } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const MappingWrapper = (props) => {

  const [list, setList] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [total, setTotal] = useState('');
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const csvRef = useRef();
  const [csvData, setCsvData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [fileName, setFileName] = useState('');
  const [csvErrorData, setCsvErrorData] = useState([]);
  

  useEffect(() => {
    uploadedCSVlist();
    // eslint-disable-next-line
  }, [pageNumber, csvData]);

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => {
      setFlag(false);
    }, 3000);
  };

  function uploadedCSVlist() {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/uploadedcsvlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        page: pageNumber,
        limit: limit,
        request_from: 'mapping'
      }
    })
    .then(response => {
      if (response.data.status === 'success') {
        setList(response.data.data);
        setTotal(response.data.total);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
    })
    .catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  }

  const handleFiles = (e) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    const _file = e.target.files[0];

    var reader = new FileReader();
    reader.onload = e => {
      // console.log(reader.result);
    };

    reader.readAsText(_file);
    let formData = new FormData();
    formData.append('file', _file);
    axios(serverUrl + 'channel/uploadmapping', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        token: btoa(authUserId + '|' + encryptedToken),
        guestHouseId: btoa(hotelId)
      },
      data: formData
    })
    .then(response => {
      if (response.data.status === 'success') {
        showMessage('success', response.data.message);
        uploadedCSVlist();
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
    })
    .catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const download = (csvId) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/uploadedcsvlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        page: pageNumber,
        limit: limit,
        request_from: 'mapping',
        csvId
      }
    }).then(response => {
      if (response.data.status === 'success') {
        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: false,
          filename: 'mapping_error',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true
        };
        setCsvErrorData(response.data.data);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const renderCSVlist = () => {
    if (Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        var autoNumber = parseInt(id) + 1 + (pageNumber - 1) * limit;
        return (
          <div className="table_row border_t_1 border_color_1" key={id}>
            <div className="tabcel align_middle pad10">{autoNumber}</div>
            <div className="tabcel align_middle pad10">{data.file_name}</div>
            <div className="tabcel align_middle pad10">{data.first_name} {data.last_name}</div>
            <div className="tabcel align_middle pad10">{data.status}</div>
            <div className="tabcel align_middle pad10">
              {data.is_error === 1
                ? <span className='cursor_p' onClick={() => download(data.id)}>
                  <CSVLink data={csvErrorData}>Download Error Report</CSVLink> 
                </span>
                : <span className='cursor_p'>N/A </span>}
            </div>
            <div className="tabcel align_middle pad10">{data.created_on}</div>
          </div>
        );
      });
    }
  };

  const handlePageChange = pageNumber => {
    setPageNumber(pageNumber);
  };

  return (
    <Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot10 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Upload Mapping</div>
          </div>
          {checkRole('upload_mapping_markup') && <Fragment>
            <div className="col-xs-auto">
              {/* <ReactFileReader handleFiles={handleFiles} fileTypes={'.csv'}>
                <button className="pad12 btn1 cursor_p">Upload CSV File</button>
              </ReactFileReader> */}
              <label className="pad12 btn1 cursor_p btn" style={{ display: 'inline-block', marginBottom: 0 }}>
                Upload CSV File
                <input
                  type="file"
                  accept=".csv"
                  onChange={handleFiles}
                  style={{ display: 'none' }}
                />
              </label>
            </div>
            <div className="col-xs-auto">
              <label className="pad12 btn1 cursor_p btn" style={{ display: 'inline-block', marginBottom: 0 }}>
              Sample File Download          
                <button
                  onClick={() => window.open('/mapping_sample_file.csv', '_blank')}
                  className="pad12 btn1 cursor_p"> 
                </button>
              </label>
            </div>
          </Fragment>}
        </div>
      </div>
      {flag ? (
        <div
          className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}
        >
          {message}
        </div>
      ) : (
        ''
      )}
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx50">S.No.</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">File Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">User Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Status</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">
                  Download Error Report <span className="fa fa-file-excel-o"></span>
                </div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Date</div>
              </div>
              {renderCSVlist()}
            </div>
          </div>
          {total === 0 && !showUILoader ? (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Logs Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No result Found</div>
            </div>
          ) : (
            ''
          )}
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            /> */}
          </div>
        ) : (
          ''
        )}
      </div>
    </Fragment>
  );
};

export default MappingWrapper;
